/**
 * A staff member's name as the header shows it: "Firstname Lastname" (Arthur,
 * 19 October 2026). A leaf module, tested in web/test/staff-name.test.ts.
 *
 * The staff record has no separate first and last name fields: full_name holds
 * "Lastname, Firstname" (the form lists sort by), and display_name is the name
 * a person is greeted by (011), often a first name alone. So the header swaps
 * the halves of a name that has EXACTLY ONE comma with text on both sides, and
 * leaves every other name exactly as it is: no comma, two commas, or an empty
 * half could be anything, and a wrong guess at a person's name is worse than
 * the stored form. Header only: every list keeps the stored, surname-first form.
 */
export function firstNameFirst(name: string): string {
  const parts = name.split(',');
  if (parts.length !== 2) return name;
  const [last, first] = parts.map((p) => p.trim().replace(/\s+/g, ' ')) as [string, string];
  if (!last || !first) return name;
  return `${first} ${last}`;
}
